import React, { useState } from "react";
import { TickSquare, CloseSquare } from "iconsax-react";
import CommonTable from "../../../Components/CommonTable";
import CancelLeaveModal from "../../../Components/CancelLeaveModal";

const LeaveRequests = ({ data, nextPageUrl, prevPageUrl, onPageChange, totalCount, page, onRefresh }) => {
  const [cancelData, setCancelData] = useState(null);

  return (
    <>
      <div className="flex flex-col gap-4 md:hidden">
        {data?.results?.map((item) => (
          <div
            key={item.request_id}
            className="w-full border border-gray-200 rounded-lg bg-white p-4 flex flex-col gap-3"
          >
            <div>
              <p className="text-xs text-gray-500">Request ID</p>
              <p className="text-sm font-medium text-gray-800">
                {item.request_id}
              </p>
            </div>

            <div className="grid grid-cols-2 gap-y-3 gap-x-6">
              <div>
                <p className="text-xs text-gray-500">Name</p>
                <p className="text-sm font-medium text-gray-800">
                  {item.employee_name}
                </p>
              </div>

              <div>
                <p className="text-xs text-gray-500">Department</p>
                <p className="text-sm font-medium text-gray-800">
                  {item.department}
                </p>
              </div>

              <div>
                <p className="text-xs text-gray-500">Leave Dates</p>
                <p className="text-sm font-medium text-gray-800">
                  {item.leave_dates}
                </p>
              </div>

              <div>
                <p className="text-xs text-gray-500">Type</p>
                <p className="text-sm font-medium text-gray-800">
                  {item.category}
                </p>
              </div>

              {/* <div> */}
                {/* <p className="text-xs text-gray-500">Reason</p> */}
                {/* <p className="text-sm font-medium text-gray-800 truncate"> */}
                  {/* {item.reason} */}
                {/* </p> */}
              {/* </div> */}

              <div>
                <p className="text-xs text-gray-500">Approved By</p>
                <p className="text-sm font-medium text-gray-800">
                  {item.approved_by || "— — — —"}
                </p>
              </div>
            </div>

            <div className="flex gap-2 mt-2">
              {item.status === "pending" && (
                <button onClick={() => setCancelData({ row: item, type: "leave" })} className="text-red-500 text-sm w-full sm:w-auto bg-red-100 hover:bg-red-600 text-white font-medium py-2 px-4 me-2 rounded-md shadow-md flex items-center justify-center space-x-2 transition duration-150">Cancel Leave</button>
              )}
              {item.status === "approved" && (
                <button onClick={() => setCancelData({ row: item, type: "request" })} className="text-red-500 text-sm w-full sm:w-auto bg-red-100 hover:bg-red-600 text-white font-medium py-2 px-4 me-2 rounded-md shadow-md flex items-center justify-center space-x-2 transition duration-150">Cancel Leave Request</button>
              )}
            </div>
          </div>
        ))}
      </div>
      <div className="hidden md:block">
        <CommonTable
          data={data?.results || []}
          rowKey="request_id"
          nextPageUrl={nextPageUrl}
          prevPageUrl={prevPageUrl}
          onPageChange={onPageChange}
          totalCount={totalCount}
          page={page}
          columns={[
            { key: "request_id", label: "Request Id" },
            // { key: "employee_name", label: "Name" },
            // { key: "department", label: "Department" },
            { key: "leave_dates", label: "Leave Dates" },
            { key: "category", label: "Category" },
            { key: "reason", label: "Reason", render: (v) => <div className="max-w-xs truncate">{v}</div> },
            { key: "approved_by", label: "Approved By" },
            {
              key: "status", label: "Status",
              render: (v) => (
                <span
                  className={`px-3 py-1 rounded-full text-xs font-medium capitalize ${
                    v === "approved" ? "bg-green-100 text-green-600" : 
                    v === "rejected" || v === "cancelled" ? "bg-red-100 text-red-600" : 
                    v === "pending" ? "bg-yellow-100 text-yellow-600" : 
                    "bg-gray-100 text-gray-600"
                  }`}
                > {v} </span>
              ),
            },
            {
              key: "cancellation_status", label: "Action",
              render: (v, row) => {
                if (row?.cancellation_status !== "none") {
                  return <span className={`px-3 py-1 rounded-full text-xs font-medium capitalize ${
                    v === "approved" ? "bg-green-100 text-green-600" : 
                    v === "rejected" || v === "cancelled" ? "bg-red-100 text-red-600" : 
                    v === "pending" ? "bg-yellow-100 text-yellow-600" : 
                    "bg-gray-100 text-gray-600"
                  }`}>Cancellation {row?.cancellation_status}</span>;
                }
                if (row.status === "pending") {
                  return (
                    <button
                      role="actions"
                      onClick={() => setCancelData({ row, type: "leave" })}
                      className="text-red-500 text-sm font-medium hover:underline px-2 py-2 bg-red-50 rounded"
                    >
                      Cancel Leave
                    </button>
                  );
                }
                if (row.status === "approved") {
                  return (
                    <button
                      onClick={() => setCancelData({ row, type: "request" })}
                      role="actions"
                      className="text-red-500 text-sm font-medium  px-2 py-2 bg-red-50 rounded"
                    >
                      Cancel Leave Request
                    </button>
                  );
                }
                return <span className={`px-3 py-1 rounded-full text-xs font-medium capitalize ${
                  v === "approved" ? "bg-green-100 text-green-600" : 
                  v === "rejected" || v === "cancelled" ? "bg-red-100 text-red-600" : 
                  v === "pending" ? "bg-yellow-100 text-yellow-600" : 
                  "bg-gray-100 text-gray-600"
                }`}>{row?.status}</span>;
              }
            }
          ]}
        // rowActions={(row) =>
        //   row.actions ? (
        //     <div className="flex items-center justify-center gap-2">
        //       <TickSquare size="20" color="#166534" variant="Bold" />
        //       <CloseSquare size="20" color="#ef4444" variant="Bold" />
        //     </div>
        //   ) : (
        //     <span className="text-gray-500 font-medium">{row.status}</span>
        //   )
        // }
        />
      </div>
      {cancelData && (
        <CancelLeaveModal
          open={!!cancelData}
          onClose={() => setCancelData(null)}
          data={cancelData.row}
          isRequest={cancelData.type === "request"}
          onRefresh={onRefresh}
        />
      )}
    </>
  );
};

export default LeaveRequests;
